import React from 'react';
import { Controller } from 'react-hook-form';
import { Switch, FormControlLabel, FormHelperText } from '@mui/material';

const SwitchInput = ({ name, label, control, setValue, onChangeForm, errorMessage }) => {
    return (
        <div>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <FormControlLabel
                        label={label}
                        control={
                            <Switch
                                {...field}
                                checked={!!field.value} // Ensure it's a boolean value
                                onChange={(e) => {
                                    setValue(name, e.target.checked);
                                    field.onChange(e);

                                    if (onChangeForm) {
                                        onChangeForm(e.target.checked);
                                    }
                                }}
                            />
                        }
                        labelPlacement="start"

                    />
                )}
            />
            {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
        </div>
    );
};

export default SwitchInput;
